import { useEffect } from 'react'
import Header from '../Header'
import { Outlet, useLocation } from 'react-router-dom'
import MobileBottomNavbar from '../Header/MobileBottomNavbar'
import { subscribeToGreyhoundMatchesData, subscribeToHorseMatchesData, subscribeToMatchData } from '../../../socketClient';

function LayoutFullPage() {
    const location = useLocation();

    useEffect(() => {
        // Subscribe to all matches for each sport
        subscribeToMatchData({
            eventId: 4, // Cricket
            competitionId: null,
            matchId: null,
            marketId: null,
            sport: "cricket",
        });
        subscribeToMatchData({
            eventId: 1, // Soccer (fixed order to match your backend convention)
            competitionId: null,
            matchId: null,
            marketId: null,
            sport: "soccer",
        });
        subscribeToMatchData({
            eventId: 2, // Tennis
            competitionId: null,
            matchId: null,
            marketId: null,
            sport: "tennis",
        });
        subscribeToGreyhoundMatchesData();
        subscribeToHorseMatchesData();
    }, []);

    return (
        <div className="" style={{ display: "flex", flexDirection: "column" }}>
            <Header />
            <div className='h-[56px] w-full' />

            {/* <div style={{ height: "calc(100vh - 112px)", overflowY: "auto" }}> */}
            <div style={{ height: "100%", overflowY: "auto", paddingBottom: "100px" }}>

                <Outlet />
            </div>

            {/* <div className='h-[56px] w-full' /> */}

            {/* {!"/full-market".includes(window.location.pathname)&& */}
            <div className='w-full mt-4' style={{ position: "fixed", bottom: 0, }} >
                <MobileBottomNavbar />
            </div>
            {/* } */}
        </div>
    )
}

export default LayoutFullPage